// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> axia-residential-arc-living-preferred -> the-blakely
// Generated: 2026-10-01T17:23:37.245Z
// Counts: 5 design, 91 content, 28 slot group, 5 collection binding, 11 section, 2 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  },
  "design._site.color.hyperlink": {
    "cssVariable": "--vibe-color-hyperlink",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_color_3"
  },
  "design._site.color.linkHover": {
    "cssVariable": "--vibe-color-link-hover",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_color_3"
  },
  "design._site.color.linkVisited": {
    "cssVariable": "--vibe-color-link-visited",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_color_3"
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<p>Modern Features You'll Love</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<p>Spaces Designed Around Your Lifestyle</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Thoughtfully designed floor plans for the way you live.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Modern Living. Resort-Inspired Comfort.</h2><h2><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments Homes in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Blakely in Pendergrass, GA, enjoy spacious <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">one-, two-, and three-bedroom apartments</a> in a well-connected North Georgia location. Situated in Jackson County, the community offers convenient access to nearby destinations, including Jefferson and Braselton, placing shopping, dining, and everyday essentials within a short drive. Residents are also close to popular attractions such as <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/neighborhood\">Tanger Outlets Commerce</a> and Château Élan Winery &amp; Resort.</p><p>Outdoor recreation and regional destinations are all nearby, including Hurricane Shoals Park, Shields-Ethridge Heritage Farm, and scenic areas throughout North Georgia. Downtown Jefferson and Braselton further expand lifestyle options with local dining, shopping, and community events, creating a balanced living experience with convenience, recreation, and connectivity all close to home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "Luxury Apartments in Pendergrass ",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "Welcome to The Blakely in Pendergrass, GA",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibilitystatement.heading": {
    "overrideType": "VALUE",
    "customValue": " ",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibilitystatement.intro": {
    "overrideType": "VALUE",
    "customValue": "<p></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-map.config_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_repli_id"
  },
  "applynowactions.show_application_block": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "callrail-tracking.account_hash": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_call_rail_account_hash"
  },
  "callrail-tracking.company_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_call_rail_company_id"
  },
  "contactus.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe.height": {
    "overrideType": "VALUE",
    "customValue": "1600",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe.height_mobile": {
    "overrideType": "VALUE",
    "customValue": "1600",
    "generatedValue": null,
    "mappedField": null
  },
  "iframe-embed.height": {
    "overrideType": "VALUE",
    "customValue": "2000",
    "generatedValue": null,
    "mappedField": null
  },
  "iframe-embed.url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "preferredemployerprogram.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Exclusive Apartment Offers for Employees in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.form.source": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.scheduler_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "scheduleatour.show_tour_scheduler": {
    "overrideType": "VALUE",
    "customValue": "false",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.height": {
    "overrideType": "VALUE",
    "customValue": "1400",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019ddf82-4a2b-7415-9f55-0532545ea814.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Blakely in Pendergrass, GA, luxury meets comfort in a thoughtfully designed apartment community where every detail enhances your lifestyle. Residents enjoy two resort-style swimming pools with sun decks, outdoor kitchens with TVs, a state-of-the-art fitness center, and a lively game room—creating the perfect balance of relaxation and entertainment.</p><p>Inside our <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">smart home apartments in Pendergrass, GA</a>, modern finishes elevate your living experience with granite countertops, wood-style flooring, matte black accents, tile backsplash, and stainless-steel appliances. Each apartment is also designed with smart home convenience, including features like a Nest thermostat for added comfort and control. Spacious one-, two-, and three-bedroom floor plans offer both style and functionality, creating a refined place to call home. With additional amenities like a dedicated bark park and cozy fire pits, The Blakely is built for comfort, connection, and everyday enjoyment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>We'd love to show you around. Contact our leasing team today to schedule your personal tour, ask questions, or explore current availability. We can't wait to welcome you home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Find Your Perfect Space</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card2.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Browse photos of the spaces, amenities, and everyday moments waiting for you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card2.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Life Looks Better Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card3.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Resort-style amenities designed to make every day more enjoyable.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card3.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Everything You Need, Right Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe-2.height": {
    "overrideType": "VALUE",
    "customValue": "1600",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe-2.height_mobile": {
    "overrideType": "VALUE",
    "customValue": "1600",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 24px;\"><strong>Find the Floor Plan That Fits Your Lifestyle</strong></span></p><p>At The Blakely in Pendergrass, GA, your ideal living space awaits with beautifully designed one-, two-, and three-bedroom apartment homes that blend comfort, style, and functionality. Each floor plan is thoughtfully crafted to complement your lifestyle, offering spacious layouts and inviting living areas in a modern apartment community in Pendergrass.</p><p></p><p>Inside your home, refined details create a balance of elegance and convenience. Enjoy features such as expansive walk-in closets, wood-style flooring, and custom-design finishes throughout. Kitchens are enhanced with granite countertops, shaker-style cabinetry, and modern appliances, while a Nest thermostat adds smart-home convenience. Large balconies and patios provide a private outdoor retreat, perfect for relaxing at home.</p><p></p><p>Browse our available floor plans at The Blakely and discover apartment living in Pendergrass, GA designed with both style and everyday comfort in mind.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.label": {
    "overrideType": "VALUE",
    "customValue": "1 - 3",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Blakely in Pendergrass, GA—near Jefferson, GA—everyday living feels elevated and inviting. Imagine relaxing poolside at one of <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/amenities\">two resort-style swimming pools</a>, gathering with friends in the outdoor kitchens, or enjoying a laid-back evening in the game room. Throughout the community, thoughtfully designed spaces create a setting that blends comfort, connection, and modern apartment living.</p><p>Inside, spacious one-, two-, and three-bedroom apartment homes feature warm, modern interiors that complement the lifestyle. Browse our photo gallery to experience life at The Blakely and envision your next apartment home in Pendergrass, GA, just minutes from Jefferson, GA.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/pet-friendly-apartments-pendergrass-ga-blakely::hyperlocalpagecopy.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Find the ideal home for you and your furry friends at The Blakely, renowned for its pet friendly apartments in Pendergrass, GA. Nestled in the serene Jackson County, our community offers <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\"><u>spacious floor plans designed with both comfort and style</u></a> in mind. Enjoy the convenience of stainless-steel appliances and the luxury of matte black accents while knowing your pets are safe in a gated environment.</p><p>Our state-of-the-art fitness center, featuring On Demand Fitness, and multiple fire pits provide perfect relaxation and recreation options after a day of pet adventures. With Pendergrass's charming surroundings and our community's welcoming atmosphere, The Blakely ensures that you and your pets will always feel at home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 24px;\"><strong>Connected to Everything That Matters</strong></span></p><p>Embrace life at The Blakely in Pendergrass, GA, where convenient apartment living places you just minutes from I-85, offering easy access to some of the most popular destinations in Jackson County and the greater North Georgia region. From here, residents can enjoy shopping at Tanger Outlets Commerce or a short drive to Château Élan Winery &amp; Resort for dining and wine experiences.</p><p>Outdoor recreation and local attractions are close by, including Hurricane Shoals Park, Sell’s Mill Park, and Braselton Park. For unique local shopping and community experiences, La Vaquita Flea Market is also nearby. Residents enjoy convenient access to Jefferson, GA, featuring historic downtown charm, Jefferson Memorial Stadium, and Panther Stadium, along with fitness options such as Anytime Fitness and The Rig Gym. With direct connectivity via I-85, The Blakely offers a well-connected lifestyle surrounded by dining, recreation, shopping, and entertainment throughout Pendergrass, Jefferson, and the surrounding area.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>The Blakely in Pendergrass, GA is a pet-friendly apartment community designed to welcome both residents and their furry companions. Our thoughtfully designed apartment homes and community spaces help create a comfortable living environment for you and your pets alike, making it easy to feel at home in Pendergrass.</p><p></p><p>For more information about our pet policy or details on living in our <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">pet-friendly apartments in Pendergrass, GA</a>, please contact our leasing team. We’re happy to provide guidance and help you find the right home for you and your pet at The Blakely.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerprogram.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>Program benefits are subject to change and require valid proof of employment at move-in. Contact our leasing office to confirm current eligibility and available offers.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerprogram.employers_list": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p>Medical Personnel (Any County)</p></li><li><p>School System Employees (Jackson County)</p></li><li><p>Police Departments (Any County)</p></li><li><p>Veterans or Military Personnel</p></li><li><p>Fire Department (Any County)</p></li><li><p>Kubota</p></li><li><p>Carters Distribution Center</p></li><li><p>ALDI's</p></li><li><p>Amazon</p></li><li><p>Havertys Furniture Distribution Center</p></li><li><p>HomeGoods</p></li><li><p>PetCo Distribution</p></li><li><p>SK Battery</p></li><li><p>Walmart Distribution Center</p></li><li><p>Walgreens CO/Distribution Center</p></li><li><p>Government Departments (Any County)</p></li><li><p>Resilux American LLC</p></li><li><p>Mission Foods</p></li><li><p>QT Distribution</p></li><li><p>Siemens</p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Blakely, home is more than where you live—it's where your days begin with comfort and end with relaxation. Spacious one, two, and three-bedroom apartment homes feature granite countertops, wood-style flooring, walk-in closets, and in-home washers and dryers, creating a space that's as functional as it is beautiful.</p><p>Outside your front door, you'll discover two resort-style pools, outdoor gathering spaces, a state-of-the-art fitness center, game room, theater room, bark park, playground, and EV charging stations—all thoughtfully designed to make everyday living easier.</p><p>Whether you're commuting, entertaining friends, or simply enjoying a quiet evening at home, The Blakely offers the comfort, convenience, and lifestyle you've been searching for.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.tour.source": {
    "overrideType": "VALUE",
    "customValue": "entrata",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Blakely in Pendergrass, GA, finding the right apartment home is simple with our thoughtfully designed <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">one-, two-, and three-bedroom floor plan layouts</a>. Each apartment offers a balance of comfort and functionality, creating a modern living experience in a well-connected Pendergrass location.</p><p>Explore our apartment community from anywhere with a virtual tour and get a closer look at the layouts, design, and atmosphere before you visit. Discover available apartment floor plan options at The Blakely and envision your next home in Pendergrass, GA.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_online_leasing_url"
      }
    }
  },
  "_template:hyperlocal::hyperlocalhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_featured_image"
      }
    }
  },
  "featuring/apartment-with-pool-monroe-30655::hyperlocalhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_featured_image"
      }
    }
  },
  "amenitieshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings."
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02ca-7703-7779-8ff7-dfad852dc9b5.webp"
      }
    }
  },
  "contacthero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[7].image_media.alt_text"
      },
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[7].image"
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": 5,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Elegant bedroom with a large bed, nightstands, and a window with blinds."
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f3-0474-7358-92d2-165d279f96f9.webp"
      }
    }
  },
  "ctasection.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f3-259e-74cc-a2ac-ca62e7acb616.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor amenities including a pool, covered pavilion, and fire pits at a multifamily property."
      }
    }
  },
  "ctasection.card3_image": {
    "sourceIndex": 16,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f1-d7ca-754c-91f7-05f8dfae32a7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a breakfast bar with grey stools."
      }
    }
  },
  "floorplanshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Open-concept living and dining area with a modern kitchen."
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02c9-e404-75de-a9ee-06ff73c77599.webp"
      }
    }
  },
  "floorplanslist.card_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f3-96b9-7369-b34b-c821259130b4.webp"
      }
    }
  },
  "floorplanslist.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f3-38c4-7558-a579-adbdb86cd0f0.webp"
      }
    }
  },
  "floorplanslist.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f2-fa1d-750c-b77d-301e03d71c2f.webp"
      }
    }
  },
  "floorplanslist.card_viewall": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02c9-e404-75de-a9ee-06ff73c77599.webp"
      }
    }
  },
  "galleryhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious high-ceilinged common area with modern seating, a fireplace, and a television."
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d743c-3242-729f-a769-5def8c136cbd.webp"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f3-259e-74cc-a2ac-ca62e7acb616.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor amenities including a pool, covered pavilion, and fire pits at a multifamily property."
      }
    }
  },
  "neighborhoodcallout.image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[10].poi_featured_image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[10].poi_featured_image_media.alt_text"
      }
    }
  },
  "neighborhoodcallout.image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[1].poi_featured_image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[1].poi_featured_image_media.alt_text"
      }
    }
  },
  "neighborhoodcallout.image_3": {
    "sourceIndex": 29,
    "fieldOverrides": null
  },
  "neighborhoodhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[11].poi_featured_image_media.alt_text"
      },
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[11].poi_featured_image"
      }
    }
  },
  "petpolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "A Bengal cat and Yorkshire Terrier playfully reach for a feathered toy indoors."
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/01a0167b-5fff-7481-b776-d22a29965a66.webp",
        "valueSource": "stock"
      }
    }
  },
  "residentaccesshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Resident access banner featuring an exterior view of The Blakely apartment community pool, with the apartment building in the background."
      }
    }
  },
  "scheduleatourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[13].image_media.alt_text"
      },
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[13].image"
      }
    }
  },
  "virtualtourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Community lounge with shuffleboard, pool table, and seating areas."
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02ca-64e2-76e6-82dc-ea93a90970db.webp"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": null,
    "hiddenIds": [
      "custom_556f2e45-e585-4dcc-8187-a903fa5c65df",
      "custom_71ed5905-676a-4c72-986a-8319d3e9334c",
      "custom_e176e208-6adf-43a0-a77e-6ab576083400"
    ],
    "orderedIds": [
      "custom_537456a4-748d-4a3c-91e2-51177e901384",
      "custom_d515d197-9a9e-4548-a7ba-9610711a677b",
      "custom_1a81f83a-8ef6-40cb-8fd4-071a63674940",
      "custom_a7d6c10c-b92e-46c7-91ee-aa1a3eaaacad",
      "custom_8003e5a5-712c-4f29-a49c-e44e6a04ca36",
      "custom_2b594bc8-dccc-4593-9ea2-f94f6382f12f",
      "custom_e6b82325-469c-4818-9c71-580ea8e6daa4",
      "custom_39bec49d-048e-4384-96be-6881f002a66d",
      "custom_66cd02fb-189c-44e8-9fa7-2c134181e3e3",
      "custom_5be91160-a6d5-4dc9-99be-61bd02615786",
      "custom_71ed5905-676a-4c72-986a-8319d3e9334c",
      "custom_e176e208-6adf-43a0-a77e-6ab576083400",
      "custom_9e090ebb-cd52-49c2-8530-a0e909c93e4c",
      "custom_556f2e45-e585-4dcc-8187-a903fa5c65df",
      "custom_f27011d7-1df7-47ef-8b2d-f184d630150d",
      "custom_36a274d5-91e3-4f5c-8c68-69ac78c3711a",
      "custom_7c944e88-e684-44dc-a417-4a85ead3f047",
      "custom_433a5479-64e1-49b1-b7fa-c1f651277f49",
      "custom_1222cc7f-1008-439a-a5b4-cb5191554830",
      "custom_d1f263d7-8768-4462-87ab-258adaa6625a",
      "custom_e71cdcd0-b16f-42b6-994b-861761ac37d4",
      "custom_dac40906-da4a-4a8a-97d9-a4e041774a0f",
      "custom_5e686188-d3f7-4462-8038-df510b1d2292",
      "custom_3f184473-0790-48dd-86ba-6c8e3fb87075",
      "custom_8530cc86-8b66-47b8-a2da-ba06ccf75bad",
      "custom_347cae44-8854-43e0-b70a-7091dedd94cc",
      "custom_5b068063-44a8-4331-ab46-e9858cc902ea",
      "custom_e912d66a-f326-4ab4-843b-9112d8676204",
      "custom_63be35f0-7e9c-494a-9bd1-0ae691b4efab",
      "custom_8068c770-f24a-45af-b055-485db053f091",
      "custom_e22ce0b0-16ec-4c51-b18f-e9ded6dea8bd",
      "custom_f5905fed-fe3b-476f-857f-4b23d397e0a2",
      "custom_a7d671e9-50b6-4202-a370-686beb04c45a",
      "custom_8ed4a050-d6e9-4138-93f4-09c76d1f946c",
      "custom_5dd0b488-5f2c-48aa-bcaa-8d60ec491a4c",
      "custom_d71b751d-2d7c-4811-9eab-3d96f3d6e5ff",
      "custom_9206af5d-33da-4a6f-9c7b-da89fbcaa068",
      "custom_6aafb167-695a-472a-9246-7bdbe43d417f",
      "custom_0bc9f08d-96a5-4b9a-a0f2-9bad46b36c57",
      "custom_b9fd8166-68ae-4d6e-a5f9-41509653a5c5",
      "custom_8d3e7d30-e9d9-4feb-a5f5-2555e4125b2d",
      "custom_7934d3b7-3007-4764-8c6e-042e593a1493",
      "custom_982aa09a-c452-48af-97da-9cff989f137a",
      "custom_11856258-91c2-4538-9112-58154821ffd1",
      "custom_687a53c8-6ecc-4fbe-b08d-04abe6d59a3f",
      "custom_09847c05-62f1-4262-9084-1c08ddc0fbae",
      "custom_a0ee0822-4dfa-4c26-8760-84b597a2cc52",
      "custom_1ff64295-e9df-46cc-ac12-3dbd473a17df",
      "custom_7c074fe6-1d09-4e53-aac6-1264c3478e45",
      "custom_51c1707e-ddf4-434e-a850-6baf0ce28c96"
    ],
    "hiddenIndices": [
      9,
      7,
      1
    ],
    "ordering": [
      2,
      0,
      3,
      4,
      5,
      6,
      8,
      10,
      11,
      12,
      7,
      1,
      13,
      9,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49
    ],
    "customItems": null
  },
  "amenitieslist.communityPhotos": {
    "limit": null,
    "hiddenIds": [
      "custom_e176e208-6adf-43a0-a77e-6ab576083400",
      "custom_a7d6c10c-b92e-46c7-91ee-aa1a3eaaacad",
      "custom_2b594bc8-dccc-4593-9ea2-f94f6382f12f",
      "custom_36a274d5-91e3-4f5c-8c68-69ac78c3711a",
      "custom_1a81f83a-8ef6-40cb-8fd4-071a63674940",
      "custom_537456a4-748d-4a3c-91e2-51177e901384",
      "custom_e22ce0b0-16ec-4c51-b18f-e9ded6dea8bd"
    ],
    "orderedIds": [
      "custom_71ed5905-676a-4c72-986a-8319d3e9334c",
      "custom_8068c770-f24a-45af-b055-485db053f091",
      "custom_d515d197-9a9e-4548-a7ba-9610711a677b",
      "custom_8003e5a5-712c-4f29-a49c-e44e6a04ca36",
      "custom_f27011d7-1df7-47ef-8b2d-f184d630150d",
      "custom_5be91160-a6d5-4dc9-99be-61bd02615786",
      "custom_7c944e88-e684-44dc-a417-4a85ead3f047",
      "custom_d1f263d7-8768-4462-87ab-258adaa6625a",
      "custom_e22ce0b0-16ec-4c51-b18f-e9ded6dea8bd",
      "custom_537456a4-748d-4a3c-91e2-51177e901384",
      "custom_e176e208-6adf-43a0-a77e-6ab576083400",
      "custom_36a274d5-91e3-4f5c-8c68-69ac78c3711a",
      "custom_1a81f83a-8ef6-40cb-8fd4-071a63674940",
      "custom_a7d6c10c-b92e-46c7-91ee-aa1a3eaaacad",
      "custom_39bec49d-048e-4384-96be-6881f002a66d",
      "custom_2b594bc8-dccc-4593-9ea2-f94f6382f12f",
      "custom_e6b82325-469c-4818-9c71-580ea8e6daa4",
      "custom_556f2e45-e585-4dcc-8187-a903fa5c65df",
      "custom_66cd02fb-189c-44e8-9fa7-2c134181e3e3",
      "custom_9e090ebb-cd52-49c2-8530-a0e909c93e4c",
      "custom_433a5479-64e1-49b1-b7fa-c1f651277f49",
      "custom_1222cc7f-1008-439a-a5b4-cb5191554830",
      "custom_e71cdcd0-b16f-42b6-994b-861761ac37d4",
      "custom_dac40906-da4a-4a8a-97d9-a4e041774a0f",
      "custom_5e686188-d3f7-4462-8038-df510b1d2292",
      "custom_3f184473-0790-48dd-86ba-6c8e3fb87075",
      "custom_347cae44-8854-43e0-b70a-7091dedd94cc",
      "custom_5b068063-44a8-4331-ab46-e9858cc902ea",
      "custom_e912d66a-f326-4ab4-843b-9112d8676204",
      "custom_63be35f0-7e9c-494a-9bd1-0ae691b4efab",
      "custom_f5905fed-fe3b-476f-857f-4b23d397e0a2"
    ],
    "hiddenIndices": [
      1,
      4,
      6,
      15,
      3,
      2,
      29
    ],
    "ordering": [
      7,
      28,
      0,
      5,
      14,
      12,
      16,
      19,
      29,
      2,
      1,
      15,
      3,
      4,
      10,
      6,
      8,
      9,
      11,
      13,
      17,
      18,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      30
    ],
    "customItems": null
  },
  "gallery.images": {
    "limit": null,
    "hiddenIds": [
      "custom_e176e208-6adf-43a0-a77e-6ab576083400",
      "custom_2b594bc8-dccc-4593-9ea2-f94f6382f12f",
      "custom_556f2e45-e585-4dcc-8187-a903fa5c65df",
      "custom_39bec49d-048e-4384-96be-6881f002a66d",
      "custom_433a5479-64e1-49b1-b7fa-c1f651277f49",
      "custom_e912d66a-f326-4ab4-843b-9112d8676204",
      "custom_63be35f0-7e9c-494a-9bd1-0ae691b4efab",
      "custom_e22ce0b0-16ec-4c51-b18f-e9ded6dea8bd"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      1,
      6,
      9,
      10,
      17,
      27,
      28,
      30
    ],
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "callrail-tracking",
      "blockId": "callrail-tracking",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 8
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 9,
      "gridSpanMobile": 12
    }
  ],
  "schedule-a-tour": [
    {
      "sectionId": "elise-schedule-tour-iframe",
      "blockId": "elise-schedule-tour-iframe",
      "position": 8,
      "visible": false
    },
    {
      "sectionId": "elise-schedule-tour-iframe-2",
      "blockId": "elise-schedule-tour-iframe",
      "position": 9
    }
  ],
  "apply-now": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 8,
      "visible": false
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  },
  "_section.block:iframe-embed": {
    "properties": {
      "overflow": "hidden"
    }
  }
};
